import React from 'react';

import styles from './Color.module.scss';

export interface ColorObject {
  name: string;
  weights: Array<number>;
  hexValues: Array<string>;
}

export interface Props {
  colors: Array<ColorObject>;
}

export const Color: React.FC<Props> = props => (
  <div className={styles.color}>
    <div className={styles.swatches}>
      {props.colors.map(color => (
        <div key={color.name} className={styles.swatchGroup}>
          <h6 className={styles.heading}>
            {`${color.name[0].toUpperCase()}${color.name.slice(1)}`}
          </h6>
          {color.weights.map((weight, i) => (
            <div className={styles.swatchContainer}>
              <div
                key={weight}
                className={styles.swatch}
                style={{
                  background: color.hexValues[i],
                  color: i >= 3 ? 'white' : undefined,
                }}
              >
                <pre className={styles.swatchText}>{color.hexValues[i]}</pre>

                <pre className={styles.swatchText}>
                  $
                  {color.hexValues[i] === '#ffffff'
                    ? 'white'
                    : `${color.name}${weight}`}
                </pre>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
);

Color.displayName = 'Color';
export default Color;
